import emblemaOuroUrl from '../../assets/marca/pg-emblema-ouro.png';
import emblemaRosaUrl from '../../assets/marca/pg-emblema-rosa.png';
import tipografiaOuroUrl from '../../assets/marca/pg-tipografia-ouro.png';

/**
 * Identidade visual PG Custom no ERP — logos OFICIAIS (as mesmas dos
 * protótipos aprovados `pg_custom_*`). O emblema dourado é a marca
 * principal; o emblema rosa é acento visual de destaque, usado com
 * parcimônia (nunca substitui o dourado, nunca é recriado em SVG). O
 * Vite resolve cada import para a URL final com hash, servida tanto na
 * raiz de `painel.pgcustom.com.br` quanto sob `/admin` (mesma pasta
 * `dist/`, `base: '/admin/'` no `vite.config`).
 */
export const MARCA_PG = {
  emblemaOuro: emblemaOuroUrl,
  emblemaRosa: emblemaRosaUrl,
  tipografiaOuro: tipografiaOuroUrl,
} as const;
